<template>
  <EcxSidebarBase :expanded="open">
    <!-- Logo Slot -->
    <template #logo="{ expanded }">
      <RouterLink to="/tela-inicial" class="relative z-10 w-10 h-10 flex items-center justify-center bg-white">
        <img 
          v-if="expanded"
          src="@/assets/images/ecx_logo.webp" 
          class="max-w-[70px] w-auto h-auto duration-300" 
          alt="ecxpay_logo"
        />
        <img 
          v-else
          src="@/assets/images/small_logo.webp" 
          class="w-auto h-auto max-w-[28px] duration-300" 
          alt="ecxpay_logo"
        />
      </RouterLink>
    </template>

    <!-- Navigation Items -->
    <template #default="{ expanded }">
      <EcxNavItem
        :expanded="expanded"
        to="/tela-inicial"
        :label="t('button.dashboard')"
        v-slot="{ isActive }"
      >
        <HomeGradientIcon class="w-5 h-5" :active="isActive" />
      </EcxNavItem>
      
      <EcxNavItem
        :expanded="expanded"
        to="/grupos"
        :label="t('button.groups')"
        v-slot="{ isActive }"
      >
        <UserGroupGradientIcon class="w-5 h-5" :active="isActive" />
      </EcxNavItem>
      
      <EcxNavItem
        :expanded="expanded"
        to="/colaboradores"
        :label="t('button.collaborators')"
        v-slot="{ isActive }"
      >
        <PersonGradientIcon class="w-5 h-5" :active="isActive" />
      </EcxNavItem>
      
      <EcxNavItem
        :expanded="expanded"
        to="/carga"
        :label="t('button.charge')"
        v-slot="{ isActive }"
      >
        <ChargeGradientIcon class="w-5 h-5" :active="isActive" />
      </EcxNavItem>
      
      <EcxNavItem
        :expanded="expanded"
        to="/relatorios"
        :label="t('button.reports')"
        v-slot="{ isActive }"
      >
        <ReportGradientIcon class="w-5 h-5" :active="isActive" />
      </EcxNavItem>
      
      <EcxNavItem
        :expanded="expanded"
        to="/solicitar-cartao"
        :label="t('button.card_solicitation')"
        v-slot="{ isActive }"
      >
        <CardGradientIcon class="w-5 h-5" :active="isActive" />
      </EcxNavItem>
      
      <EcxNavItem
        :expanded="expanded"
        to="/adiantamento-salarial"
        :label="t('button.wage_advance')"
        v-slot="{ isActive }"
      >
        <AnteciPayGradientIcon class="w-5 h-5" :active="isActive" />
      </EcxNavItem>
    </template>
  </EcxSidebarBase>
</template>

<script setup lang="ts">
import { useI18n } from '@/composables/useI18n';
import { useSidebarStore } from '@/stores/sidebar';
import { storeToRefs } from 'pinia';

import { EcxSidebar as EcxSidebarBase, EcxNavItem } from '@ecx/ui';
import {
  HomeGradientIcon,
  UserGroupGradientIcon,
  PersonGradientIcon,
  ChargeGradientIcon,
  ReportGradientIcon,
  CardGradientIcon,
  AnteciPayGradientIcon,
} from '@ecx/ui';

const sideStore = useSidebarStore();
const { open } = storeToRefs(sideStore);

const { t } = useI18n();
</script>
